import React from 'react';

interface SectionTitleProps {
  children: React.ReactNode;
  /** Optional right-aligned mono meta (e.g. "Last 30 days"). */
  meta?: React.ReactNode;
  /** Optional trailing affordance (e.g. the section FeedbackButton). */
  action?: React.ReactNode;
}

/**
 * The grouping primitive for sheet/menu content: mono eyebrow + hairline
 * rule + optional meta. Reused by the profile sections today and the brand
 * dropdown groups next.
 */
const SectionTitle: React.FC<SectionTitleProps> = ({ children, meta, action }) => (
  <div className="tend-section">
    <span className="tend-section-title">{children}</span>
    {/* Action hugs the title (consistent across sections regardless of
        how much furniture a section's meta carries). */}
    {action}
    <i className="tend-section-rule" aria-hidden="true" />
    {meta && <span className="tend-section-meta">{meta}</span>}
  </div>
);

export default SectionTitle;
